module.exports = __webpack_public_path__ + "static/img/areaA-22.988927b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-22.png
// module id = 934
// module chunks = 1